"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var arrowStyles = function arrowStyles(_ref) {
  var variant = _ref.variant;
  return {
    backgroundColor: variant === 'dark' ? 'secondary.default' : 'white'
  };
};
var _default = exports["default"] = arrowStyles;